import { PButtonPure, PLinkPure } from "@porsche-design-system/components-react"
import { FormattedMessage } from "react-intl"
import { Link, useNavigate } from "react-router"
import { commonMessages } from "src/common/messages/common.messages"

export interface BackNavigationProps {
	backUrl?: string // if no backUrl is provided, it will navigate back in history
	hideLabel?: boolean
}

export const BackNavigation = ({ backUrl, hideLabel }: BackNavigationProps) => {
	const navigate = useNavigate()

	if (backUrl) {
		return (
			<PLinkPure icon="arrow-left" hideLabel={hideLabel}>
				<Link to={backUrl} data-testid="backnavigation">
					<FormattedMessage {...commonMessages.back} />
				</Link>
			</PLinkPure>
		)
	}

	return (
		<PButtonPure
			type="button"
			icon="arrow-left"
			onClick={() => navigate(-1)}
			hideLabel={hideLabel}
			data-testid="backnavigation"
		>
			<FormattedMessage {...commonMessages.back} />
		</PButtonPure>
	)
}
